import axios from 'axios';
export function getUnitProductTypeId(endpoint) {
    return axios.get(endpoint).then((data) => data.data.unitProductTypeId);
}
export function getCategoriesOfProduct(endpoint) {
    return axios.get(endpoint).then((data) => data.data);
}
export function getProductByName(endpoint, text, locale, offset = 0) {
    return axios
        .get(endpoint, {
        params: {
            text,
            locale,
            sort: 'variants.attributes.productYear desc|name.en asc',
            limit: 10,
            offset,
            includeArchived: true,
        },
    })
        .then((data) => data.data.results);
}
export function getProductByType(endpoint, offset = 0, hasRequestProductLimit = false) {
    return axios
        .get(endpoint, {
        params: {
            sort: 'id desc',
            offset,
            includeArchived: true,
            ...(hasRequestProductLimit && {
                limit: 10,
            }),
        },
    })
        .then((data) => data.data.results);
}
